// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"8cdf156a","764":"30bd57f6"}[chunkId] + ".chunk.js";
};